import { Helmet } from "react-helmet"
import LayoutDashboard from "../../../components/layouts/layout_dashboard"
import BtnBack from "../../../components/buttons/btn_back"
import CustomHeader from "../../../components/customs/header"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import BtnDefault from "../../../components/buttons/btn_default"
import CustomCurrency from "../../../components/customs/currency"
import { showUnitSelling } from "../../../services/unit/unit_selling_service"
import { BaseUrl } from "../../../services/base/base_url"
import { getUnitSellingPayments } from "../../../services/unit/unit_selling_payment_service"
import CustomAlert from "../../../components/customs/alert"
import NewSellingPayment from "./new_payment"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEdit, faPlus, faTrash, faX, faXmark } from "@fortawesome/free-solid-svg-icons"
import FormatDateV2 from './../../../components/format/date_v2';
import CustomSpinner from "../../../components/customs/spinner"
import CustomConfirm from "../../../components/customs/confirm"
import SellingUpdate from "./update/selling_update"
import TransactionUpdate from "../financial/transaction/update"
import SubmitUpdate from "../financial/transaction/function_update"

const SellingDetail = () => {
    const [accessToken, setAccessToken] = useState('');
    const [userRole, setUserRole] = useState('');
    const navigate = useNavigate()
    const { id } = useParams()
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [loadingPayment, setLoadingPayment] = useState(false);

    const [openModalAdd, setOpenModalAdd] = useState(false)

    const [sellingId, setSellingId] = useState(null)

    const [data, setData] = useState(null);
    const fetchData = async (accessToken) => {
        setLoading(true);

        const response = await showUnitSelling(accessToken, id);
        if (response.status === 200) {
            setData(response.data.data);
        }

        setLoading(false);
    };

    const [dataPayment, setDataPayment] = useState([])
    const fetchDataPayment = async (accessToken) => {
        setLoadingPayment(true);
        try {
            const response = await getUnitSellingPayments(accessToken, id);
            if (response.status === 200) {
                setDataPayment(response.data.data);
            }
        } catch (error) {
            console.log("__")
        }

        setLoadingPayment(false);
    };

    useEffect(() => {
        try {
            if (refresh === true) {
                fetchData(accessToken)
                fetchDataPayment(accessToken)
                setRefresh(false)
            }
        } catch (error) {
            alert("Silahkan periksa koneksi internet Anda..!");
        }

    }, [refresh])

    useEffect(() => {
        try {
            const newAccessToken = localStorage.getItem('access_token-terra_app') ?? ''
            const newUserRole = localStorage.getItem('user_role-terra_app') ?? ''
            if (!newAccessToken) {
                navigate('/login')
            } else if (!['super admin', 'admin', 'lapangan', 'keuangan'].includes(newUserRole)) {
                navigate('/403')
            } else {
                setAccessToken(newAccessToken)
                setUserRole(newUserRole)
                fetchData(newAccessToken)
                fetchDataPayment(newAccessToken)
            }
        } catch (error) {
            // alert("Silahkan periksa koneksi internet Anda..!");
        }
    }, [id]);

    const MyRow = ({ name, value, addClass }) => {
        return (
            <tr className={addClass}>
                <td className="w-[120px] md:w-auto">{name}</td>
                <td className="px-2">:</td>
                <td>{value}</td>
            </tr>
        )
    }

    const [openAlert, setOpenAlert] = useState(false)
    const [messageAlert, setMessageAlert] = useState("")
    const [typeAlert, setTypeAlert] = useState("")

    const [openDropdown, setOpenDropdown] = useState("")
    const [loadingSubmit, setLoadingSubmit] = useState("")

    const [openConfirm, setOpenConfirm] = useState(false)
    const [loadingConfirm, setLoadingConfirm] = useState(false)
    const handleConfirm = async () => {

    }

    const [openUpdate, setOpenUpdate] = useState(false)
    const [dataUpdate, setDataUpdate] = useState(null)
    const [categoryUpdate, setCategoryUpdate] = useState("update")

    const [openUpdateTransaction, setOpenUpdateTransaction] = useState(false)
    const [dataUpdateTransaction, setDataUpdateTransaction] = useState(null)
    const [deletedId, setDeletedId] = useState("")
    const [loadingDelete, setLoadingDelete] = useState(false)
    const [categoryUpdateTransaction, setCategoryUpdateTransaction] = useState(false)
    const [openConfirmDeleteTransaction, setOpenConfirmDeleteTransaction] = useState(false)

    return (
        <>
            <Helmet>Detail Penjualan</Helmet>
            <LayoutDashboard>
                <CustomHeader>
                    <BtnBack />
                    <p className="text-center uppercase">Detail Penjualan</p>
                    <div className="flex items-center justify-end" >
                        {/* {['super admin', 'admin'].includes(userRole) && */}
                        <div className="flex items-center justify-end relative">
                            <BtnDefault handleClick={() => setOpenDropdown(!openDropdown)}>
                                <FontAwesomeIcon icon={faEdit} />
                                <span>Aksi</span>
                            </BtnDefault>

                            <div className={`absolute w-fit bg-white top-16 rounded-2xl flex flex-col items-center justify-center gap-3 px-5 transition-all duration-300 overflow-hidden ${openDropdown ? "h-[120px] border shadow-md" : "h-0 border-none shadow-none"} `}>
                                <button
                                    onClick={() => {
                                        setOpenUpdate(true)
                                        setDataUpdate(data)
                                        setCategoryUpdate("update")
                                    }}
                                    className="bg-yellow-500 hover:bg-yellow-600 transition-colors w-[180px] rounded-full py-2 font-semibold text-white flex items-center justify-center px-3 text-sm">
                                    {loadingSubmit ? <CustomSpinner addClass="bg-white" /> : "Gagalkan Penjualan..?"}
                                </button>
                                <button
                                    onClick={() => {
                                        setOpenUpdate(true)
                                        setDataUpdate(data)
                                        setCategoryUpdate("delete")
                                    }}
                                    className="bg-red-500 hover:bg-red-600 transition-colors w-[180px] rounded-full py-2 font-semibold text-white flex items-center justify-center px-3 text-sm">
                                    {loadingSubmit ? <CustomSpinner addClass="bg-white" /> : "Hapus Penjualan..?"}
                                </button>
                            </div>
                        </div>
                        {/* // } */}
                    </div>
                </CustomHeader>

                <div className="px-3 pt-2 pb-3 flex flex-col gap-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-3 items-start">
                        <table className={loading === true ? 'w-full' : 'w-fit'}>
                            {
                                loading === true ?
                                    Array.from({ length: 3 }).map(() => (
                                        <tr className="animate-pulse">
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2 w-16">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                        </tr>
                                    )) :
                                    <>
                                        <MyRow name="Nama Lengkap" value={data?.consument?.name ?? <p className="text-center bg-red-500 text-white font-semibold px-3  rounded-md">Konsumen sudah dihapus..!</p>} />
                                        <MyRow name="Nomor Telepon" value={data?.consument?.phone_number.replace(/(\d{4})(?=\d)/g, "$1 ") ?? "-"} />
                                        <MyRow name="Email" value={data?.consument?.email ?? "-"} />
                                    </>
                            }
                        </table>
                        <table className={loading === true ? 'w-full' : 'w-full'}>
                            {
                                loading === true ?
                                    Array.from({ length: 2 }).map(() => (
                                        <tr className="animate-pulse">
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2 w-16">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                        </tr>
                                    )) :
                                    <>
                                        <MyRow name="Waktu Dibuat" value={<>
                                            <FormatDateV2 date={data?.date ?? ''} />
                                        </>} />
                                        <MyRow name="Status" value={<>
                                            <div
                                                className={`${data?.status?.name === "gagal"
                                                    ? "bg-red-500"
                                                    : data?.status?.name === "dalam proses"
                                                        ? "bg-yellow-500" : "bg-green-500"
                                                    } rounded-full text-center font-semibold text-white md:py-1 px-3 text-xs md:text-sm`}
                                            >
                                                {data?.status?.name}
                                            </div>
                                        </>} />
                                        <MyRow name="Status Pembayaran" value={<>
                                            <div
                                                className={`${data?.payment_status?.name === "belum dibayar"
                                                    ? "bg-red-500"
                                                    : data?.payment_status?.name === "dibayar sebagian"
                                                        ? "bg-yellow-500" : "bg-green-500"
                                                    } rounded-full text-center font-semibold text-white md:py-1 px-3 text-xs md:text-sm`}
                                            >
                                                {data?.payment_status?.name}
                                            </div>
                                        </>} />
                                    </>
                            }
                        </table>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 pt-3">
                        <div>
                            <p className="font-semibold border-b-2 border-black mb-2">Alamat</p>
                            <p className="text-justify">{data?.consument?.address ?? "-"}</p>
                        </div>

                        <div>
                            <p className="font-semibold border-b-2 border-black mb-2">Foto KTP</p>
                            <div className={`w-full aspect-video rounded-xl overflow-hidden relative flex items-center justify-center border ${loading ? 'bg-gray-300 animate-pulse' : ''}`}>
                                {!loading &&
                                    data?.consument?.ktp ?
                                    <img
                                        src={`${BaseUrl}/storage/${data?.consument?.ktp}`}
                                        alt="image terra app"
                                        layout="fill"
                                        loading="lazy"
                                        className="w-full aspect-video object-cover"
                                    /> : <FontAwesomeIcon icon={faXmark} className="text-2xl" />
                                }
                            </div>
                        </div>

                        <div>
                            <p className="font-semibold border-b-2 border-black mb-2">Foto Kartu Keluarga</p>
                            <div className={`w-full aspect-video rounded-xl overflow-hidden relative flex items-center justify-center border ${loading ? 'bg-gray-300 animate-pulse' : ''}`}>
                                {!loading &&
                                    data?.consument?.kk ?
                                    <img
                                        src={BaseUrl + "/storage/" + data?.consument?.kk}
                                        alt="image terra app"
                                        layout="fill"
                                        loading="lazy"
                                        className="w-full aspect-video object-cover"
                                    /> : <FontAwesomeIcon icon={faXmark} className="text-2xl" />
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 px-3 gap-3">
                    <div>
                        <p className="px-3 py-2 bg-custom-dark-yellow text-black font-semibold rounded-xl">Data Unit</p>
                        <table className={`max-w-screen-2xl ${loadingPayment === true || dataPayment.length === 0 ? 'minw-max md:min-w-full' : 'min-w-max md:min-w-full'}`}>
                            {
                                loading === true ?
                                    Array.from({ length: 4 }).map(() => (
                                        <tr className="animate-pulse">
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2 w-16">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                        </tr>
                                    )) :
                                    <>
                                        <MyRow name="Nama Unit" value={data?.unit?.name ?? 'Tidak Tersedia'} />
                                        <MyRow name="Biaya Proses" value={<CustomCurrency value={data?.unit?.cost_of_booking ?? 0} />} />
                                        <MyRow name="DP" value={<CustomCurrency value={data?.unit?.dp ?? 0} />} />
                                        <MyRow name="Biaya Hook" value={<CustomCurrency value={data?.unit?.cost_of_hook ?? 0} />} />
                                        <MyRow name="Biaya Akad" value={<CustomCurrency value={data?.unit?.cost_of_akad ?? 0} />} />
                                        <MyRow name="Biaya Notaris" value={<CustomCurrency value={data?.unit?.cost_of_notaris ?? 0} />} />
                                    </>
                            }
                        </table>
                    </div>

                    <div>
                        <p className="px-3 py-2 bg-custom-dark-yellow text-black font-semibold rounded-xl">Data Tagihan</p>
                        <table className={`max-w-screen-2xl ${loading === true || dataPayment.length === 0 ? 'min-w-max md:min-w-full' : 'min-w-max md:min-w-full'}`}>
                            {
                                loading === true ?
                                    Array.from({ length: 4 }).map(() => (
                                        <tr className="animate-pulse">
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2 w-16">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                            <td className="px-3 py-2">
                                                <div className="w-full h-4 rounded-full bg-gray-300" />
                                            </td>
                                        </tr>
                                    )) :
                                    <>
                                        <MyRow name="Tagihan Biaya Proses" value={<CustomCurrency value={data?.remaining_booking ?? 0} />} />
                                        <MyRow name="Tagihan DP" value={<CustomCurrency value={data?.remaining_dp ?? 0} />} />
                                        <MyRow name="Tagihan Biaya Hook" value={<CustomCurrency value={data?.remaining_hook ?? 0} />} />
                                        <MyRow name="Tagihan Biaya Akad" value={<CustomCurrency value={data?.remaining_akad ?? 0} />} />
                                        <MyRow name="Tagihan Biaya Notaris" value={<CustomCurrency value={data?.remaining_notaris ?? 0} />} />
                                        <MyRow addClass="font-semibold" name="Total Tagihan" value={<CustomCurrency value={(data?.remaining_booking ?? 0) + (data?.remaining_dp ?? 0) + (data?.remaining_hook ?? 0) + (data?.remaining_akad ?? 0) + (data?.remaining_notaris ?? 0)} />} />
                                    </>
                            }
                        </table>
                    </div>
                </div>

                <div className="w-full flex flex-col gap-3 p-3">
                    <div className="px-3 py-2 bg-custom-dark-yellow text-black font-semibold rounded-xl flex items-center justify-between">
                        <p className="">Riwayat Transaksi</p>
                        {data?.remaining_booking || data?.remaining_hook !== 0 || data?.remaining_dp !== 0 || data?.remaining_akad || data?.remaining_notaris ?
                            <BtnDefault handleClick={() => setOpenModalAdd(true)}>
                                <FontAwesomeIcon icon={faPlus} />
                                <p className="hidden md:flex">Pembayaran Baru</p>
                            </BtnDefault> : ""
                        }
                    </div>

                    <div className="w-full overflow-auto scrollbar-thin scrollbar-track-custom-dark-yellow scrollbar-thumb-custom-navy scrollbar-track-rounded-full scrollbar-thumb-rounded-full pb-3">
                        <table className={`${loading === true ? 'w-full' : 'min-w-max md:min-w-full'} max-w-screen-2xl`}>
                            <thead>
                                <tr className="bg-custom-dark-yellow">
                                    <th className="px-3 py-2 rounded-tl-xl " >No</th>
                                    <th className="px-3 py-2" colSpan={2}>Aksi</th>
                                    <th className="px-3 py-2 " >Tanggal</th>
                                    <th className="px-3 py-2 " >No Ref</th>
                                    <th className="px-3 py-2 " >Nominal</th>
                                    <th className="px-3 py-2 " >Masuk Ke</th>
                                    <th className="px-3 py-2 rounded-tr-xl text-center">Keterangan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading ?
                                    dataPayment.length === 0 ? "Tidak ada data" :
                                        dataPayment?.map((item, index) => (
                                            <tr className={`${index % 2 === 1 ? 'bg-gray-200' : ''} hover:bg-gray-300 transition-all duration-300`}>
                                                <td className="px-3 py-2 text-center">{index + 1}</td>
                                                <td className="px-3 py-2  text-center" >
                                                    <button
                                                        type='button'
                                                        onClick={() => {
                                                            setDeletedId(item?.id)
                                                            setDataUpdateTransaction(item)
                                                            setCategoryUpdateTransaction("delete")
                                                            // setOpenConfirm(true)
                                                            setOpenUpdateTransaction(true)
                                                        }}
                                                        className='text-white bg-red-500 rounded-md px-3 py-2 hover:bg-red-600 transition-colors'
                                                    >
                                                        <FontAwesomeIcon icon={faTrash} />
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2  text-center" >
                                                    <button
                                                        type='button'
                                                        onClick={() => {
                                                            setDataUpdateTransaction(item)
                                                            setCategoryUpdateTransaction("update")
                                                            setOpenUpdateTransaction(true)
                                                        }}
                                                        className='text-white bg-yellow-500 rounded-md px-3 py-2 hover:bg-yellow-600 transition-colors'
                                                    >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </button>
                                                </td>
                                                <td className="px-3 py-2 text-center">
                                                    <FormatDateV2 date={item?.date ?? ''} />
                                                </td>
                                                <td className="px-3 py-2 text-center">{item?.code}</td>
                                                <td className="px-3 py-2 text-end"> <CustomCurrency value={item?.nominal} /></td>
                                                <td className="px-3 py-2 text-start">{item?.account_to?.account?.id} - {item?.account_to?.account?.name}</td>
                                                <td className="px-3 py-2 text-start">{item?.description}</td>
                                            </tr>
                                        )) :
                                    Array.from({ length: 5 }).map(() => (
                                        <tr className="animate-pulse">
                                            {Array.from({ length: 6 }).map(() => (
                                                <td className="px-3 py-2">
                                                    <div className="w-full h-4 rounded-full bg-gray-300" />
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                }
                                <tr className="bg-custom-dark-yellow">
                                    <td className="py-4" colSpan={10} />
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <CustomAlert
                    open={openAlert}
                    setOpen={setOpenAlert}
                    message={messageAlert}
                    type={typeAlert}
                />

                <NewSellingPayment
                    accessToken={accessToken}
                    open={openModalAdd}
                    setOpen={setOpenModalAdd}
                    setRefresh={setRefresh}
                    getSellingId={id}
                    getTotalPayment={data?.remaining_booking + data?.remaining_hook + data?.remaining_dp + data?.remaining_akad + data?.remaining_notaris}
                    setOpenAlert={setOpenAlert}
                    setMessageAlert={setMessageAlert}
                    setTypeAlert={setTypeAlert}
                />

                <CustomConfirm
                    open={openConfirm}
                    setOpen={setOpenConfirm}
                    type="danger"
                    message="Apakah Anda yakin akan menggagalkan penjualan ini..?"
                    handleConfirm={handleConfirm}
                />

                <SellingUpdate
                    accessToken={accessToken}
                    open={openUpdate} setOpen={setOpenUpdate}
                    setRefresh={setRefresh}
                    id={id}
                    category={categoryUpdate}
                    setOpenAlert={setOpenAlert}
                    setMessageAlert={setMessageAlert}
                    setTypeAlert={setTypeAlert}
                />

                <TransactionUpdate
                    accessToken={accessToken}
                    open={openUpdateTransaction} setOpen={setOpenUpdateTransaction}
                    setRefresh={setRefresh}
                    data={dataUpdateTransaction}
                    setOpenAlert={setOpenAlert} setMessageAlert={setMessageAlert} setTypeAlert={setTypeAlert}
                    category={categoryUpdateTransaction}
                />


                <CustomConfirm
                    handleConfirm={(e) => {
                        const paramData = {
                            "id": deletedId,
                            "category": "delete"
                        }

                        SubmitUpdate(
                            e,
                            accessToken,
                            paramData,
                            loadingDelete,
                            setLoadingDelete,
                            false,
                            null,
                            setOpenAlert,
                            setMessageAlert,
                            setTypeAlert
                        )
                    }}
                    message={"Apakah Anda yakin akan melakukan permintaan hapus data..?"}
                    open={openConfirmDeleteTransaction}
                    setOpen={setOpenConfirmDeleteTransaction}
                />

            </LayoutDashboard>
        </>
    )
}

export default SellingDetail